//
//

import { mapActions } from "vuex";
import AQLeftSideBar from "@/components/Generics/AQLeftSideBar/AQLeftSideBar.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import { IntegrationCard } from "@/components/Generics/AQCard";
import CreateIntegrationModal from "./CreateIntegrationModal.vue";

export default {
    name: "GlobalIntegration",
    components: {
        AQButton,
        AQEmptyState,
        AQSkeleton,
        AQLeftSideBar,
        CreateIntegrationModal,
        IntegrationCard
    },
    data() {
        return {
            integrationUsed: false,
            openNewIntegration: false,
            integrations: [],
            openEditIntegration: false,
            integrationData: {},
            skeletonState: true,
            emptyState: false
        };
    },
    computed: {
        createIntegrationProps() {
            return {
                integrationUsed: this.integrationUsed,
                isEdit: this.openEditIntegration,
                integrationData: this.integrationData
            };
        }
    },
    created() {
        this.getIntegrationList();
    },
    methods: {
        ...mapActions("GDM", ["getIntegrations", "checkIntegration", "isIntegrationUsed"]),
        testConnection(index) {
            this.integrations[index].status = "pending";
            const { connectionCode } = this.integrations[index];
            this.checkIntegration(connectionCode).then(data => {
                if (data && data.status === 200) {
                    this.integrations[index].status = "connected";
                } else {
                    this.integrations[index].status = "error";
                }
                this.integrations = [...this.integrations];
            }).catch(() => {
                this.integrations[index].status = "error";
                this.integrations = [...this.integrations];
            });
        },
        createIntegration() {
            this.openNewIntegration = true;
            this.integrationData = {};
            this.openEditIntegration = false;
        },
        getIntegrationList() {
            this.skeletonState = true;
            this.getIntegrations().then(({ data: { dbConnections = [] } = {} } = {}) => {
                if (!dbConnections.length) {
                    this.emptyState = true;
                }
                this.integrations = [];
                this.skeletonState = false;
                dbConnections.forEach(item => {
                    if (item.dbType === "ORACLE" && item.username) {
                        const role = item.username.split(" ");
                        item.role = role[role.length - 1];
                    }
                    this.integrations.push({ ...item, status: "" });
                });
            });
        },
        openEditModal(data) {
            this.isIntegrationUsed(data.connectionCode).then((isDeletable) => {
                this.integrationUsed = !isDeletable.data;
                this.integrationData = data;
                this.openNewIntegration = true;
                this.openEditIntegration = true;
            });
        }
    }
};
